import React, { Component } from "react";
import { Box, Select, Text, Input, Flex } from "@chakra-ui/react";
import { formatISO, parseISO, format, add } from 'date-fns';
import _ from "lodash";
import { DatePicker } from "antd";
import LocalStorageService from "../../../../services/LocalStorageService";
import dayjs from "dayjs";

import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faSyncAlt } from "@fortawesome/free-solid-svg-icons";


import {summaryBatchSearchSchema}  from "../../../../models/SummaryBatchSearchSchema";

const { RangePicker } = DatePicker;



export default class SummarySearchStrip extends Component 
{

  constructor(props) {
    super(props);
    this.state =
    {
      searchSchema: null,
      selectedObservation: null
    }

    this.localStorageService = new LocalStorageService();

    this.refreshSearchFields = this.refreshSearchFields.bind(this);
    this.onRangeChange = this.onRangeChange.bind(this);
    this.updateSearchParams = this.updateSearchParams.bind(this);
    this.getSearchUiComponent = this.getSearchUiComponent.bind(this);
  }

  componentDidMount()
  {
      this.refreshSearchFields();
  }

  componentDidUpdate(prevProps)
  {
    if (prevProps.searchParamsKey !== this.props.searchParamsKey)
    {
      this.refreshSearchFields();
    }
  }

  refreshSearchFields()
  {
    let searchSchema = summaryBatchSearchSchema; //(this.props.searchParams.schemaId) ? this.props.searchParams.schemaId : this.props.currentSchemaId;
    //var schema = this.localStorageService.getSchema(searchSchemaId);
    //var searchSchema = schema.search;
    this.setState({searchSchema: searchSchema});
  }


  updateSearchParams(ev) 
  {
    console.log("changing " + ev.target.name + " to " + ev.target.value);
    var newSearchParams = this.props.searchParams; //_.cloneDeep(this.props.searchParams);
    newSearchParams[ev.target.name] = ev.target.value;
    this.props.onSearchParamsChange(newSearchParams);
  }


  onRangeChange(ev)
  {
    console.log("range changed");
    console.log(ev);
    // don't do anything until we get both dates.
    if ((!ev[0]) || (!ev[1])) return;

    var sd = new Date(ev[0].$y, ev[0].$M, ev[0].$D); //, ev[0].$H, ev[0].$m);
    var ed = new Date(ev[1].$y, ev[1].$M, ev[1].$D); //, ev[0].$H, ev[0].$m);
    var newSearchParams = _.cloneDeep(this.props.searchParams);
    newSearchParams["eventStartDate"] = formatISO(sd);
    newSearchParams["eventEndDate"] = formatISO(ed);
    this.props.onSearchParamsChange(newSearchParams);
  }




  getSearchUiComponent(schemaField)
  {
    // custom types are expected to be handled by the render component itself (e.g. date range fields)
    if (schemaField.uiType === "custom") return <span/>;

    return <Box style={{minWidth: "fit-content"}}>
    <Text margin='0' color='white' fontSize='12px'>{schemaField.title}</Text>
    {(schemaField.options) ?
      <Select
        bg='white'
        //value={this.props.searchParams.inspector}
        value={this.props.searchParams[schemaField.searchParam]}
        name={schemaField.id}
        key={schemaField.id}
        id={schemaField.id}
        onChange={ev => this.updateSearchParams(ev)}
       >
        {schemaField.options.map((opt) => (
          <option key={opt.value} value={opt.value}>{opt.label}</option>
        ))}
      </Select>
      :
      <Input bg='white' key={schemaField.id} id={schemaField.id} name={schemaField.id} onBlur={ev => this.updateSearchParams(ev)}/>

    }
  </Box>
  }





  render() 
  {

    return (
      // <HStack justify='center'>

      <Flex flexWrap={"wrap"} justifyContent={"space-between"}>

        <Box style={{minWidth: "fit-content"}}>
          <Text margin='0' color='white' fontSize='12px'>Date Range</Text>
          <RangePicker 
          defaultValue={[
            dayjs(format(parseISO(this.props.searchParams.eventStartDate ?? formatISO(add(new Date(), { days: -5 }))), "yyyy-MM-dd")), 
            dayjs(format(parseISO(this.props.searchParams.eventStartDate ?? formatISO(add(new Date(), { days: 1 }))), "yyyy-MM-dd"))
          ]}
          format='YYYY-MM-DD'
          name="eventStartDate"
          id="eventStartDate"
          key="eventStartDate"
          size='large'
          needConfirm={false}
          onCalendarChange={ev => this.onRangeChange(ev)}
           //onOk={ev => this.onRangeChange(ev)}
          />
        </Box>
   
            
        {
            this.state.searchSchema?.baseFields?.map((fld) =>
            {
                return this.getSearchUiComponent(fld)
            })
        }

        {
          this.state.searchSchema?.searchFields?.map((fld) =>
          {
                return this.getSearchUiComponent(fld);
          })
        }

        {(this.props.isLoading) && 
          <FontAwesomeIcon icon={faSyncAlt} color="green" spin />
        }
    </Flex>
   
    );

  }




}